// credit: https://github.com/google/recaptcha/issues/130#issuecomment-362308382
const iOSRecaptcha = (() => {
  const recaptchaElements = document.querySelectorAll('.g-recaptcha'),
        HEADER_HEIGHT = 0, // Height of header/menu fixed if exists
        isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  let grecaptchaPosition;

  const isScrolledIntoView = (elem) => {
    var elemRect = elem.getBoundingClientRect();
    var isVisible = (elemRect.top - HEADER_HEIGHT >= 0 && elemRect.bottom <= window.innerHeight);
    
    return isVisible;
  };

  return {
    init: () => {
      if (isIOS && recaptchaElements.length > 0) {
        window.addEventListener('scroll', function () {
          Array.prototype.forEach.call(recaptchaElements, function (element) {
            if (isScrolledIntoView(element)) {
              grecaptchaPosition = document.documentElement.scrollTop || document.body.scrollTop;
            }
          });
        }, false);
      }
    },
    onReCaptchaSuccess: () => {
      if (isIOS && grecaptchaPosition !== undefined) {
        console.log(grecaptchaPosition)
        window.scrollTo(0, grecaptchaPosition);
      }
    }
  }

})();

export default iOSRecaptcha;


// WEBPACK FOOTER //
// ./src/js/components/form-ios-captcha.js